import { Card, CardBody, CardContent } from '@one-thd/sui-atomic-components';
import { ItemImages } from './ItemImages';
import { filterAndConsolidateLineItems } from '../../utils';
import { FulfillmentCardHeader } from './FulfillmentCardHeader';
import { useCommonContext } from '../../contexts/common-context';
import { IDistributionView } from '../../models/active-orders';

export const FulfillmentCard = ({
  distribution,
  customerType,
  onCardClick,
}: {
  distribution: IDistributionView;
  customerType: string;
  onCardClick: () => void;
}) => {
  const { isMobile } = useCommonContext();
  const allLineItems = filterAndConsolidateLineItems(distribution);

  const cardStyles = isMobile
    ? 'sui-min-w-[192px] sui-max-w-[192px] sui-min-h-[192px] sui-max-h-[192px]'
    : 'sui-min-w-[280px]';

  return (
    <Card
      // TODO: add shadow styles if needed
      // sui-shadow-base
      className={`sui-rounded-lg ${cardStyles} `}
      data-testid="fulfillment-card"
      disablePadding
      CardContentProps={{
        className: 'sui-h-full sui-flex sui-flex-col sui-w-full sui-cursor-pointer',
      }}
    >
      <CardContent
        className="sui-h-full sui-p-4"
        onClick={() => onCardClick()}
        data-testid="fulfillment-card-content"
      >
        <FulfillmentCardHeader
          distribution={distribution}
          customerType={customerType}
          isMobile={isMobile}
        />
        <CardBody>
          <ItemImages lineItems={allLineItems} isMobile={isMobile} />
        </CardBody>
      </CardContent>
    </Card>
  );
};
